import { axiosNoAuth } from '../../config/axiosInstances';
import { Api_url } from '../../common/api_url';
import { API_XANO_BASE_URL } from '../../config/api_config';
import { SET_ALL_COURSES } from './types';


export function getAllCourses(successCallback, errorCallback) {
    return async function (dispatch) {
        try {
            let response = await axiosNoAuth.get(
                API_XANO_BASE_URL + Api_url.GetAllCourses
            );
            
            dispatch({type: SET_ALL_COURSES, payload: response.data})
            successCallback && successCallback(response.data);
        } catch (e) {
            console.error(e);
            errorCallback && errorCallback(e.response.data.message);
        }
    };
}

export function getCourseById(course_slug, successCallback, errorCallback) {
    return async function (dispatch) {
        try {
            let response = await axiosNoAuth.get(API_XANO_BASE_URL + Api_url.GetCourseById,
                {
                    params: {
                        course_slug: course_slug
                    },
                }
            );

            successCallback && successCallback(response.data);
        } catch (e) {
            console.error(e);
            errorCallback && errorCallback(e.response.data.message);
        }
    };
}

export function getCoursesToGetYouStarted(successCallback, errorCallback) {
    return async function (dispatch) {
        try {
            let response = await axiosNoAuth.get(API_XANO_BASE_URL + Api_url.GetCoursesToGetYouStarted);
            successCallback && successCallback(response.data);
        } 
        catch (e) {
            console.error(e);
            errorCallback && errorCallback(e.response.data.message);
        }
    };
}

export function getDynamicBannerData(successCallback , errorCallback){
    return async function(dispatch){
        try{

            const response = await axiosNoAuth.get(API_XANO_BASE_URL + ':v1' + Api_url.GetDynamicBannerData);

            successCallback && successCallback(response.data);
        }
        catch(err){
            console.error(err);
            errorCallback && errorCallback(err);
        }
    }
}